/**
 * 订单消息类型
 */
export enum OrderMessageType {
  /**
   * 物流
   */
  Shipped = 0,
  /**
   * 退款
   */
  Refunded = 1
}

/**
 * 会话
 */
export type Conversation = {
  /**
   * 会话唯一标识
   */
  conversationId: number
  /**
   * session 标识
   */
  sessionId: number
  /**
   * 头像
   */
  headImage: string
  /**
   * 昵称
   */
  nickname: string
  /**
   * 最后一条消息原文
   */
  latestContent: string
  /**
   * 最后一条信息翻译文本
   */
  latestContentTranslate: string
  /**
   * 时间字符串
   */
  latestTime: string
  /**
   * 时间戳
   */
  latestTimestamp: number
  /**
   * 未读数
   */
  unreadCount: number
  /**
   * session 是否有效
   */
  sessionOpen: boolean
}

/**
 * 消息
 */
export type Message = {
  /**
   * 消息唯一标识
   */
  messageId: number
  /**
   * 昵称
   */
  nickname: string
  /**
   * 消息原文
   */
  content: string
  /**
   * 信息翻译文本
   */
  contentTranslate: string
  /**
   * 时间字符串
   */
  time: string
  /**
   * 时间戳
   */
  timestamp: number
  /**
   * 是否是我发的
   */
  right: boolean
  /**
   * 是否已读
   */
  read: boolean
}

/**
 * 房间
 */
export type Room = {
  roomId: string
  roomName: string
  avatar: string
  sessionId: number
  sessionOpen: boolean
  toCombineId: number
  toUserRole: number
  toUserType: number
  unreadCount: number
  hasOrder: boolean
  users: { _id: string; username: string }[]
  lastMessage: {
    content: string
    timestamp: string
    date: string
    username: string
  }
}

/**
 * 消息类型
 */
export enum MessageType {
  /**
   * 文本
   */
  Text = 'NORMAL_TEXT',
  /**
   * 文件
   */
  File = 'MULTIMEDIA_FILE_MESSAGES',
  /**
   * 图片
   */
  Picture = 'MULTIMEDIA_PICTURE_MESSAGE',
  /**
   * 视频
   */
  Video = 'MULTIMEDIA_VIDEO_MESSAGES',
  /**
   * 商品卡片
   */
  CardGoods = 'CARD_GOODS_DETAIL',
  /**
   * 订单卡片
   */
  CardOrder = 'CARD_ORDER_DETAIL'
}

/**
 * 基础报文
 */
export type BaseMessageToSend = Record<string, any>

/**
 * 待发送消息
 */
export interface ContentMessageToSend extends BaseMessageToSend {
  /**
   * 会话标识
   */
  conversationId: number
  /**
   * 消息 id
   */
  messageId: number
  /**
   * 是否需要 ack
   */
  needAck: boolean
  /**
   * 连接标识
   */
  sessionId: number
  /**
   * 消息类型
   */
  messageType: MessageType
  /**
   * 文本
   */
  content?: string
  /**
   * 卡片商品模型
   */
  cardGoods?: any
  /**
   * 卡片订单模型
   */
  cardOrder?: any
  /**
   * 媒体模型
   */
  multimedia?: {
    url: string
    fileName: string
    fileType: string
    fileSize: number
    extension: string
    fileHeight: number
    fileWidth: number
  }
  /**
   * 临时 id
   */
  applyId: string
  /**
   * 是否发送中
   */
  loading: boolean
  /**
   * 是否发送失败
   */
  failed: boolean
}

/**
 * IM消息类型
 */
export enum IMMessageType {
  /**
   * 文件
   */
  File = 'file',
  /**
   * 卡片
   */
  Card = 'card',
  /**
   * 文本
   */
  Text = 'text'
}

/**
 * im 消息文件
 */
export type IMFile = {
  name: string
  size: number
  extension: string
  type: string
  width: number
  height: number
  localUrl?: string
  preview?: string
  url?: string
  blob?: Blob
  /**
   * 是否已压缩，临时属性，最后需要同步到 IMMessage 才能在 im-sdk 传递
   */
  compressed?: boolean
}

/**
 * im 消息
 */
export type IMMessage = {
  _id: number
  applyId?: string
  content: string
  senderId: string
  roomId: number | string
  msgType?: IMMessageType
  timestamp: string
  date: string
  seen?: boolean
  /**
   * 是否是本地消息
   */
  local?: boolean
  system?: boolean
  custom?: boolean
  card?: any
  files?: IMFile[]
  /**
   * 是否正在发送
   */
  loading?: boolean
  /**
   * 是否发送失败
   */
  failed?: boolean
  /**
   * 格式化后的消息格式
   */
  messageType?: MessageType
  replyMessage?: IMMessage
  /**
   * 是否已压缩
   */
  compressed?: boolean
}

/**
 * 消息列表更新方式
 */
export enum MessageListUpdateMode {
  /**
   * 重置
   */
  Reset = 1,
  /**
   * 加载更多
   */
  LoadMore = 2,
  /**
   * 刷新
   */
  Refresh = 3
}

// 事件

/**
 * 登录成功
 */
export const EVENT_LOGIN_SUCCESS = 'loginSuccess'
export const EVENT_SOCKET_OPEN = 'socket_open' // 打开连接
export const EVENT_SOCKET_CLOSE = 'socket_close' // 断开连接
export const EVENT_SOCKET_HEART_CHECK = 'socket_heart_check' // 心跳检测
export const EVENT_SOCKET_READY = 'socket_ready' // socket 已就绪，收到 20024 报文
export const EVENT_SEND_MESSAGE_FAILURE = 'send_message_failure' // 发送消息失败

export const PING_CODE = 10006
export const PONG_CODE = 10007

export const CODE_SEND_MESSAGE = 20000
export const CODE_FETCH_MESSAGE_ID = 20022
export const CODE_CREATE_CONVERSATION = 20023
export const CODE_RECEIVE_USER_INFO = 20024
